// extracted by mini-css-extract-plugin
export default {"discountBanner":"aga","topheader":"bga","navleft":"cga","navflexelem":"ega","navright":"fga","fixedtop":"gga","abstop":"hga","subdesc":"iga","smallscreennav":"jga","nav_hidden":"kga","cancel_link":"lga","bottomnavcontainer":"mga","fixedbottom":"nga","animatedbottom":"oga","appear-bottom":"pga","delayedbottom":"qga","retakebtn":"rga","long_banner":"sga","nofixed":"tga"};
    if(module.hot) {
      // 1726593108542
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  